import { FormFieldTypes } from 'src/app/shared/components/form/form';

export const servicesMenuData = [
  {
    name: 'myContent',
    type: FormFieldTypes.TOGGLE,
    label: 'See my content only',
    required: false,
    icon: 'person',
    line: 'full',
  },
  {
    name: 'location',
    type: FormFieldTypes.SELECT,
    label: 'Location',
    multiple: true,
    required: false,
    line: 'full',
    icon: 'location',
    options: [
      'online',
      'Africa',
      'Asia',
      'Oceania',
      'North America',
      'Europe',
      'South America',
    ],
  },
  {
    name: 'type',
    type: FormFieldTypes.SELECT,
    label: 'Type',
    multiple: true,
    required: false,
    line: 'full',
    icon: 'reorder-three-outline',
    options: ['part-time', 'full-time', 'per hour', 'gig based'],
  },
  {
    name: 'startDate',
    type: FormFieldTypes.DATE,
    label: 'Start Date',
    required: false,
    line: 'full',
    icon: 'calendar',
  },
  {
    name: 'endDate',
    type: FormFieldTypes.DATE,
    label: 'End Date',
    required: false,
    line: 'full',
    icon: 'calendar',
    value: '',
  },
];

export interface IServicesFilter {
  myContent: boolean;
  location?: string;
  type?: string;
  creator: string;
  date: string;
  startDate: string;
  endDate: string;
}

export const servicePremiumModalData =
  "You've fot great services to offer to other mers? \n \n As a premium mer you'll be good to go! Go and check out our packages!";

export const imageField = {
  name: 'images',
  type: FormFieldTypes.ARRAY,
  icon: 'image',
  label: 'image',
  children: [
    {
      name: 'image',
      type: FormFieldTypes.FILE,
      label: 'image',
      required: false,
      icon: 'image',
    },
  ],
  template: {
    name: 'image',
    type: FormFieldTypes.FILE,
    label: 'image',
    required: false,
    icon: 'image',
  },
};
export const confirmAddingModalData = {
  title: 'Add a Service Search',
  icon: 'pricetag',
  okBtn: {
    title: 'YES, DISCARD',
  },
  cancelBtn: {
    title: 'NO, GO BACK',
  },
};

export const successServicesModalData = {
  title: 'Thanks for adding content!',
  pic: 'some sea animal with magnifying glass',
  description:
    "You'll get rewarded as soon as your content has been verified by 3 moderators.",
  okBtn: {
    title: 'CONTINUE',
  },
  cancelBtn: {
    title: 'SPLASH MERFRIENDS',
  },
};

export const confirmEditingModalData = {
  title: 'Edit a Service Search',
  icon: 'pricetag',
  okBtn: {
    title: 'YES, DISCARD',
  },
  cancelBtn: {
    title: 'NO, GO BACK',
  },
};

export const confirmDeletingModalData = {
  title: 'Deleting a Service Search',
  icon: 'pricetag',
  okBtn: {
    title: 'YES, DELETE',
  },
  cancelBtn: {
    title: 'NO, KEEP',
  },
};
export const serviceDiscordModalData = {
  icon: 'pricetag',
  title: 'Search for a Service',
  text: 'In order for potential clients to contact you, you need to join our membership first.',
};
